// extracted by mini-css-extract-plugin
export var centerText = "_br-8";
export var container = "_br-0";
export var doughnutContainer = "_br-7";
export var legend = "_br-a";
export var legendItemColorDisplay = "_br-b";
export var legendItemLabel = "_br-d";
export var legendItemValue = "_br-c";
export var lg = "_br-5";
export var maxWidth = "_br-9";
export var md = "_br-4";
export var responsive = "_br-6";
export var sm = "_br-3";
export var xs = "_br-2";
export var xxs = "_br-1";